<template>
  <div class="parking-list">
    <van-nav-bar title="停车场管理" fixed />
    <div class="content">
      <van-button type="primary" block @click="showAdd = true">新增停车场</van-button>
      <van-list v-model="loading" :finished="finished" @load="onLoad">
        <van-card
          v-for="item in list"
          :key="item.id"
          :title="item.name"
          :desc="item.address"
        >
          <template #tags>
            <van-tag type="success">总车位: {{item.totalSpaces}}</van-tag>
            <van-tag type="primary">可用: {{item.availableSpaces}}</van-tag>
          </template>
          <template #footer>
            <van-button size="small" @click="handleEdit(item)">编辑</van-button>
            <van-button size="small" type="danger" @click="handleDelete(item.id)">删除</van-button>
          </template>
        </van-card>
      </van-list>
    </div>

    <van-dialog v-model="showAdd" title="新增停车场" show-cancel-button @confirm="handleSubmit">
      <van-form ref="form">
        <van-field v-model="form.name" label="停车场名称" placeholder="请输入" required />
        <van-field v-model="form.address" label="地址" placeholder="请输入" required />
        <van-field v-model="form.totalSpaces" type="number" label="总车位数" placeholder="请输入" required />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import { parkingApi } from '@/api'

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      showAdd: false,
      form: {
        name: '',
        address: '',
        totalSpaces: ''
      }
    }
  },
  methods: {
    async onLoad() {
      try {
        const { data } = await parkingApi.getList()
        this.list = data
        this.finished = true
      } catch (error) {
        this.$toast.fail('加载失败')
      }
      this.loading = false
    },
    handleEdit(item) {
      this.form = { ...item }
      this.showAdd = true
    },
    async handleDelete(id) {
      this.$dialog.confirm({ message: '确定删除?' }).then(async () => {
        await parkingApi.delete(id)
        this.$toast.success('删除成功')
        this.onLoad()
      })
    },
    async handleSubmit() {
      try {
        if (this.form.id) {
          await parkingApi.update(this.form.id, this.form)
        } else {
          await parkingApi.create(this.form)
        }
        this.$toast.success('操作成功')
        this.form = { name: '', address: '', totalSpaces: '' }
        this.onLoad()
      } catch (error) {
        this.$toast.fail('操作失败')
      }
    }
  }
}
</script>

<style scoped>
.parking-list {
  padding-top: 46px;
}
.content {
  padding: 16px;
}
.van-card {
  margin-top: 12px;
}
</style>
